import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {AssignedCard} from "../interface/assigned-card.interface";
import {CommissionTemplate} from "../interface/commission-template.interface";

@Injectable({
  providedIn: 'root'
})
export class CommissionService {

  private apiUrl = `${environment.apiUrl}/commission-templates`;

  constructor(private http: HttpClient) {
  }

  getAllTemplates(): Observable<CommissionTemplate[]> {
    return this.http.get<CommissionTemplate[]>(`${this.apiUrl}/all`);
  }

  getTemplateById(id: number): Observable<CommissionTemplate> {
    return this.http.get<CommissionTemplate>(`${this.apiUrl}/${id}`);
  }

  createTemplate(request: any): Observable<CommissionTemplate> {
    return this.http.post<CommissionTemplate>(this.apiUrl, request);
  }

  updateTemplate(id: number, request: any): Observable<CommissionTemplate> {
    return this.http.put<CommissionTemplate>(`${this.apiUrl}/${id}`, request);
  }

  deleteTemplate(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  assignCards(templateId: number, userCardIds: number[]): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${templateId}/assign-cards`, {userCardIds});
  }

  getAvailableCards(): Observable<AssignedCard[]> {
    return this.http.get<AssignedCard[]>(`${this.apiUrl}/available-cards`);
  }

  getAllCards(): Observable<AssignedCard[]> {
    return this.http.get<AssignedCard[]>(`${this.apiUrl}/all-cards`);
  }

  getAssignedCards(templateId: number): Observable<AssignedCard[]> {
    return this.http.get<AssignedCard[]>(`${this.apiUrl}/${templateId}/assigned-cards`);
  }
}
